import { deepAssign } from './deep-assign';
export function deepClone(obj) {
  if (Array.isArray(obj)) {
    return obj.map(function (item) {
      return deepClone(item);
    });
  }

  if (typeof obj === 'object') {
    return deepAssign({}, obj);
  }

  return obj;
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/deep-clone.js
// module id = 1723
// module chunks = 1